import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
// import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/404',
      name: '404',
      component: () => import('./views/NotFound')
    },
    {
      // Here's the new catch all route
      path: '*',
      redirect: { name: 'home' }
    },
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home')
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/consulting',
      name: 'consulting',
      component: () => import(/* webpackChunkName: "about" */ './views/ConsultingDetail')
    },
    {
      path: '/content/:postId',
      name: 'content',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Content.vue')
    },
    {
      path: '/content/:postId/register',
      name: 'content-register',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ContentRegister.vue')
    },
    {
      path: '/product/:productId',
      name: 'product-search',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ProductSearch.vue')
    },
    {
      path: '/product/:productId/variety',
      name: 'variety',
      component: () => import(/* webpackChunkName: "about" */ './views/Variety.vue')
    },
    {
      path: '/product/:productId/variety/:varietyId',
      name: 'variety-detail',
      component: () => import(/* webpackChunkName: "about" */ './views/VarietyDetail.vue')
    },
    {
      path: '/product/:productId/workflow/:workflowRecordId',
      name: 'workflow',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Workflow.vue')
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import(/* webpackChunkName: "about" */ './views/Knowledge.vue')
    },
    {
      path: '/knowledge/:knowledgeId',
      name: 'knowledge-detail',
      component: () => import(/* webpackChunkName: "about" */ './views/KnowledgeDetail.vue')
    },
    {
      path: '/knowledge/:knowledgeId/exam',
      name: 'exam',
      component: () => import(/* webpackChunkName: "about" */ './views/Exam.vue')
    },
    {
      path: '/qrcode/detail/:qrcodeId',
      name: 'qrcode-detail',
      component: () => import('./views/QRCodeDetail.vue')
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: () => import('./views/admin/AdminLogin')
    },
    {
      path: '/admin',
      name: 'admin',
      meta: { requiresAuth: true },
      component: () => import('./views/admin/AdminMenu'),
      children: [
        {
          path: 'search-log',
          name: 'admin-search-log',
          component: () => import('./views/admin/SearchLog')
        },
        {
          path: 'consulting-topic',
          name: 'admin-consulting-topic',
          component: () => import('./views/admin/ConsultingTopic')
        },
        {
          path: 'consulting-case',
          name: 'admin-consulting-case',
          component: () => import('./views/admin/ConsultingCase')
        },
        {
          path: 'greeting',
          name: 'greeting',
          component: () => import('./views/admin/Greeting')
        },
        {
          path: 'wording-type',
          name: 'wording-type',
          component: () => import('./views/admin/WordingType')
        },
        {
          path: 'wording',
          name: 'wording',
          component: () => import('./views/admin/Wording')
        },
        {
          path: 'shop/edition',
          name: 'shop-edition',
          component: () => import('./views/admin/ShopEdition')
        },
        {
          path: 'shop/edition/product',
          name: 'shop-edition-product',
          component: () => import('./views/admin/ShopEditionProduct')
        },
        {
          path: 'shop/orders',
          name: 'shop-orders',
          component: () => import('./views/admin/ShopOrderList')
        }
      ],
      beforeEnter: (to, from, next) => {
        const currentUser = firebase.auth().currentUser
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
        if (requiresAuth && !currentUser) next({ name: 'admin-login' })
        else if (!requiresAuth && currentUser) next({ name: 'admin' })
        else next()
      }
    }
  ]
})

// router.beforeEach((to, from, next) => {
//   // console.log(to);
//   // console.log(store.state.Product.searchProductId);
//   // console.log(to.matched.some(record => record.meta.requiresAuth))
//   // if (to.matched.some(record => record.meta.requiresAuth)) {
//   //   if (store.state.Product.searchProductId) {
//   //     next()
//   //     // }
//   //   } else {
//   //     next({
//   //       name: 'home'
//   //     })
//   //   }
//   // } else {
//   //   next() // make sure to always call next()!
//   // }
// })

export default router
